import {login, logout, getInfo} from '@/api/login'
import {resetRouter} from '@/router'
import {getSystemName} from "@/api/common";
import defaultSetting from "@/settings"
import {homeRemind} from "@/api/home";
import JsEncrypt from "jsencrypt"

const publicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvOl6a70RGBN1MLzOQC3bAB0ERyVbpDp4iQjXrgHsh0CbJOPSOdV6OSRCPVfyhH5bXoPlviTT7mvDJQwue4acUxHAZA4FEkzZ9HGsOldD9sHWZTF+f6kCUdjESJnl7lO6dBExCQDgAf1udgrQHZpU5yIkhGIpAGf6aSROsiGwJlsr4KvEqK0GkRxoN9COZd7OmBBSdgtooLIaL2BacL6x4NqFBJs5+sgtmiv1Hv9BVQ0MyhOm0tMH+V2oB0hpToZWAT5cCrBsWL+YwqwhjAJhFFxiXxYE2Xh/F+LZe+vHCJ3Lcgf1UWTmL87MKLLRj0/y5NyCOCSs3T8ubHxygMoJowIDAQAB"


const getDefaultState = () => {
  return {
    token: sessionStorage.getItem('token'),
    name: '', //登录名称
    avatar: require('@/assets/header.png'),//默认头像
    roleType: '',//登录角色
    sysName: "",//系统名称
    adminId: "",//用户id
    costTotalNum: '0',//费用管理总统计
    renewNum: '0',//缴费管理数量
    funNum: '0', //功能开通申请数量,
    sourceId: "",//源id(例：企业id、行政区域id)【平台该字段为0】
    permission_btns: "",//权限id
    manageEnterpriseList: [],
    inname:sessionStorage.getItem('inname')|| ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_ROLETYPE: (state, roleType) => {
    state.roleType = roleType
  },
  SET_SYSNAME: (state, sysName) => {
    state.sysName = sysName
  },
  SET_ADMINID: (state, adminId) => {
    state.adminId = adminId
  },
  SET_COSTTOTALNUM: (state, total) => {
    state.costTotalNum = total
  },
  SET_RENEWNUM: (state, renew) => {
    state.renewNum = renew
  },
  SET_FUNNUM: (state, apply) => {
    state.funNum = apply
  },
  SET_SOURCEID: (state, sourceId) => {
    state.sourceId = sourceId
  },
  SET_BTNS(state, btns) {
    state.permission_btns = btns;
  },
  SET_manageEnterpriseList(state, list){
    state.manageEnterpriseList = list;
  },
  SET_inname(state, inname){
    state.inname = inname;
  },
}

const actions = {
  // 用户登录
  login({commit}, userInfo) {
    //rsa加密
    const jse = new JsEncrypt();
    jse.setPublicKey(publicKey);
    var param = jse.encrypt(JSON.stringify(userInfo))
    return new Promise((resolve, reject) => {
      login(param).then(response => {
        const {data} = response
        sessionStorage.setItem('token', data.token)
        commit('SET_TOKEN', data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 用户个人信息
  getInfo({commit, state}) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        if (response) {
          const {data} = response
          if (!data) {
            reject('验证失败，请重新登录.')
          }
          const {name, adminType, adminId, sourceId, funIds,manageEnterpriseList,inname} = data
          commit('SET_NAME', name)
          commit('SET_ROLETYPE', adminType)
          commit('SET_ADMINID', adminId)
          commit('SET_SOURCEID', sourceId)
          commit('SET_BTNS', funIds)
          commit('SET_manageEnterpriseList', manageEnterpriseList)
          commit('SET_inname', inname || '')
          sessionStorage.setItem('inname',inname || '')
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 退出登录
  logout({commit, state, dispatch}) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        sessionStorage.clear()
        resetRouter()
        commit('RESET_STATE')
        dispatch('tagsView/delAllViews', null, {root: true});//删除tags
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  //获取系统名称
  getSysName({commit, state}) {
    return new Promise((resolve, reject) => {
      getSystemName(state.token).then(res => {
        if (res) {
          const {data} = res;
          if (!data) {
            resolve(res.msg)
          }
          defaultSetting.title = data;
          commit('SET_SYSNAME', data)
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  //获取费用管理的统计数量
  getCostNum({commit, state}) {
    return new Promise((resolve, reject) => {
      homeRemind().then(res => {
        if (res) {
          const {data} = res;
          const {total, renew, apply} = data;
          commit('SET_COSTTOTALNUM', String(total));
          commit('SET_RENEWNUM', String(renew));
          commit('SET_FUNNUM', String(apply));
          resolve(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

